import { match } from 'ts-pattern'

import { type DataDisplayType } from '../dataDisplayType'

import { format } from './format'
import { forRatio } from './forRatio'

/**
 * 集計数をフォーマットします。
 *
 * @param count - 集計数。
 * @param ratio - 総数に対する集計数の比率。
 * @param tamRatio - 集計数と推定人口の比率。
 * @param dataDisplayType - データ表示タイプ。
 * @returns フォーマットされた文字列。
 */
export function forCount(
  count: number,
  ratio: number,
  tamRatio: number,
  dataDisplayType: DataDisplayType,
): string {
  return match(dataDisplayType)
    .with('percentage', () => forRatio(ratio))
    .with('number', () => format(count))
    .with('estimatedPopulation', () => format(count * tamRatio))
    .exhaustive()
}
